// assets/theme-toggle.js
document.addEventListener('DOMContentLoaded', function() {
  // 1) Modus setzen
  const stored = localStorage.getItem('theme');
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const initial = stored === 'dark' || (stored === null && prefersDark) ? 'dark' : 'light';
  document.documentElement.setAttribute('data-theme', initial);

  // 2) Button erzeugen
  const btn = document.createElement('button');
  btn.innerText = '🌓';
  btn.setAttribute('aria-label', 'Dark Mode umschalten');
  btn.className = 'theme-toggle';

  // 3) Klick-Handler
  btn.addEventListener('click', () => {
    const curr = document.documentElement.getAttribute('data-theme');
    const next = curr === 'dark' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', next);
    localStorage.setItem('theme', next);
  });

  // 4) Im Header einhängen
  // Hier suchen wir nach dem Header-Container. 
  // Passe ggf. den Selector an deine Struktur an.

// Versuch, das Warenkorb-Link-Element zu finden
const cartLink = document.querySelector('a[href*="/cart"]');
if (cartLink) {
  // Button direkt nach dem Warenkorb-Icon einfügen
  cartLink.insertAdjacentElement('afterend', btn);
} else {
  // Fallback: irgendeinen Icon-Container suchen
  const iconContainer =
    document.querySelector('.header__icon-list') ||
    document.querySelector('.header__icons') ||
    document.body;
  iconContainer.appendChild(btn);
}

  
});
